<script>
/* eslint-disable */
</script>
<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3335 12.25V11.0833C10.3335 10.4645 10.0877 9.871 9.65008 9.43342C9.21249 8.99583 8.619 8.75 8.00016 8.75H3.91683C3.29799 8.75 2.7045 8.99583 2.26691 9.43342C1.82933 9.871 1.5835 10.4645 1.5835 11.0833V12.25"
      stroke="#A7A7A7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.95833 6.41667C7.247 6.41667 8.29167 5.372 8.29167 4.08333C8.29167 2.79467 7.247 1.75 5.95833 1.75C4.66967 1.75 3.625 2.79467 3.625 4.08333C3.625 5.372 4.66967 6.41667 5.95833 6.41667Z"
      stroke="#A7A7A7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9165 6.41667L12.0832 7.58333L14.4165 5.25"
      stroke="#A7A7A7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>